<template>
    <div>
        <div>
            <b-nav tabs>
                <template v-if="canCustomerCustomersView">
                    <b-nav-item router-link to="customer">
                        <icon name="user-friends"></icon>
                        ข้อมูลลูกหนี้
                    </b-nav-item>&nbsp;
                </template>
                <template v-if="canCustomerCustomersView">
                    <b-nav-item router-link to="customer-other">
                        <icon name="user-friends"></icon>
                        ลูกค้าย่อย
                    </b-nav-item>&nbsp;
                </template>
                <b-nav-item v-if="canCustomerCustomersSpecialView"
                        router-link to="special-customer">
                    <icon name="user"></icon>
                    รายงานลูกค้าพิเศษ
                </b-nav-item>&nbsp;
                <template v-if="canVendorsView">
                    <b-nav-item router-link to="vendor">
                        <icon name="user"></icon>
                        ข้อมูลเจ้าหนี้
                    </b-nav-item>
                </template>
            </b-nav>
        </div>
        <div class="container-fluid" style="background-color: white">
            <router-view />
        </div>
    </div>
</template>

<script>
import {
    canCustomerCustomersView,
    canVendorsView,
    canCustomerCustomersSpecialView
} from "../../util/Permissions"

export default {
    name: "person",
    computed: {
        canCustomerCustomersView,
        canVendorsView,
        canCustomerCustomersSpecialView
    }
}
</script>

<style scoped></style>
